import React, { FunctionComponent, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { setIsFeedBanner } from 'Redux/actions/auth'
import testingModeSvg from 'Shared/img/svg/testMode.svg'

import {
  Container,
  Title,
  Description,
  TestingModeIcon,
  ButtonsContainer,
  Button,
  ButtonSimple,
} from './styles'

export const TestingModeBanner: FunctionComponent = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [testingModeBorder, setTestingModeBorder] = useState(true)

  const handleGotIt = () => {
    dispatch(setIsFeedBanner())
  }

  return (
    <Container viewed={!testingModeBorder}>
      <TestingModeIcon src={testingModeSvg} alt="" />
      <Title>{t('tracksFeedPage.testingModeBannerTitle')}</Title>
      <Description>{t('tracksFeedPage.testingModeBannerText')}</Description>
      <ButtonsContainer>
        <Button type="submit" onClick={handleGotIt}>
          {t('tracksFeedPage.gotIt')}
        </Button>
        {/* <ButtonSimple onClick={handleGotIt}>
          {t('tracksFeedPage.letsGetMore')}
        </ButtonSimple> */}
      </ButtonsContainer>
    </Container>
  )
}
